import { Heading, Paragraph } from '@zillow/constellation-10';

const VerificationCompletePage = (): JSX.Element | null => (
  <>
    <Heading level={3} textStyle="body-lg-bold">
      You’ve answered your verification questions
    </Heading>
    <Paragraph>The info you provided will help keep our service secure. You’re almost done with your setup.</Paragraph>
  </>
);

export default VerificationCompletePage;
